// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__tX6Th","col":"Table_col__1Hklb","fulfillmentStatus":"Table_fulfillmentStatus__28ycD","emailCol":"Table_emailCol__1lFNw"};